import { BlockError } from '@/blocks.04-project/block-error/block-error';
import GiftSetControl from '@/blocks.04-project/gift-set-control/gift-set-control';
import {LazyInit} from '@/blocks.04-project/lazy-init/lazy-init';

/**
 * Класс подарочного набора
 */
class GiftSet extends GiftSetControl {
	/***
	 * Конструктор класса
	 * @param selector {String|undefined} селектор для поиска блока
	 * @param options {Object} данные карточки
	 * @param elem {HTMLElement|undefined} элемент для инициализации
	 */
	constructor({ selector, options, elem }) {
		super({ blockClass: 'gift-set', selector, options, elem });

    this.BlockError = new BlockError({ blockName: 'GiftSet', destroy: this.destroy });

    this.block.GiftSet = this;
		this.block.AsyncGiftSet = new Promise((resolve) => {
			this.promiseResolve = resolve;
		}).then((ins) => ins);

		this.LazyInit = new LazyInit({ ins: this, callback: this.init.bind(this), addClass: 'gift-set_inited' });
		if (!this.bh) {
			window.getBH((bh) => {
				this.bh = bh;
				this.LazyInit.init();
			});
		} else {
			this.LazyInit.init();
		}
  }

  init() {
		super.init();
		this.promiseResolve(this);
		this.block.AsyncTabs = this;
  }

  destroy() {
		super.destroy();
    if (this.block) {
      this.block.classList.remove('gift-set_inited');
      delete this.block.GiftSet;
      delete this.block.AsyncGiftSet;
    }
  }
}

if (NOT_PROD) {
	const options = {
		data: {
			'id': 5,
			'max': 100000
		}
	};
	Array.from(document.querySelectorAll('.gift-set:not(.gift-set_inited)')).forEach((elem) => {
		new GiftSet({ elem, options });
	});
}

// Экспорт;
window.Block.GiftSet = GiftSet;

